<template lang="pug">
div.wrap-item-object-transform-changer
  div(v-if="objectProps").wrap-window.px12.py12
    div.mb8
      div(@click="showPosition = !showPosition").f.fm.flex-between
        div.f.fm
          v-icon(size="20px" dark).mr6 mdi-cursor-move
          span.label.block.fz14 位置
        v-icon(dark) {{showPosition ? 'mdi-chevron-up' : 'mdi-chevron-down'}}
      
      div(v-if="showPosition").pl4
        AtomSliderWithInput(v-model="objectProps.position.x" label="x"
          :min="positionRange.min" :max="positionRange.max" :step="positionStep" color="red" dark)
        AtomSliderWithInput(v-model="objectProps.position.y" label="y"
          :min="positionRange.min" :max="positionRange.max" :step="positionStep" color="green" dark)
        AtomSliderWithInput(v-model="objectProps.position.z" label="z"
          :min="positionRange.min" :max="positionRange.max" :step="positionStep" color="blue" dark)

    div.mb8
      div(@click="showRotation = !showRotation").f.fm.flex-between.cursor-pointer
        div.f.fm
          v-icon(size="20px" dark).mr6 mdi-rotate-3d-variant
          span.label.block.fz14 回転
        v-icon(dark) {{showRotation ? 'mdi-chevron-up' : 'mdi-chevron-down'}}
      div(v-if="showRotation && targetObjectMode === 'mesh'").pl4
        AtomSliderWithInput(v-model="objectProps.rotation.x"
          label="x" :min="-3.2" :max="3.2" :step="0.001" color="red" dark)
        AtomSliderWithInput(v-model="objectProps.rotation.y"
          label="y" :min="-3.2" :max="3.2" :step="0.001" color="green" dark)
        AtomSliderWithInput(v-model="objectProps.rotation.z"
          label="z" :min="-3.2" :max="3.2" :step="0.001" color="blue" dark)
      div(v-if="showRotation && targetObjectMode === 'sprite'").pl4
        AtomSliderWithInput(v-model="objectProps.rotation"
          :min="-3.2" :max="3.2" :step="0.01" dark)

    div
      div(@click="showScale = !showScale").f.fm.flex-between
        div.f.fm
          v-icon(size="20px" dark).mr6 mdi-arrow-expand-all
          span.label.block.fz14 大きさ
        v-icon(dark) {{showScale ? 'mdi-chevron-up' : 'mdi-chevron-down'}}
      div(v-if="showScale").pl4
        AtomSliderWithInput(v-model="objectProps.scale" label="Scale"
          :min="scaleRange.min" :max="scaleRange.max" :step="0.001" dark)
</template>

<style lang="scss" scoped>
@import "@/scss/_variables.scss";

.wrap-item-object-transform-changer {
  position: relative;
  min-height: 34px;
  .wrap-window {
    position: relative;
    width: 80vw; max-width: $studio_window_max_width;
    height: 100%;
    // background: $overlay_color;
    // border-radius: 3px;
    // box-shadow: $box_shadow;
    .label {
      color: $dark_primary_text_color;
    }
  }
}
</style>

<style lang="scss">
@import "@/scss/_variables.scss";

.wrap-item-object-transform-changer {
  .v-messages {
    display: none;
  }
}
</style>

<script>
import { createNamespacedHelpers } from 'vuex'
const { mapState: mapStateAuth } = createNamespacedHelpers('auth')
import studioManager from '@/components/mixin/studioManager'
import AtomSliderWithInput from '@/components/atom/studio/AtomSliderWithInput'
import * as THREE from 'three'

export default {
  mixins: [studioManager],
  components: {
    AtomSliderWithInput
  },
  props: {
    targetObject: {
      type: Object,
      required: true
    },
    targetObjectMode: {
      type: String,
      required: true
    },
    targetAsset: {
      type: Object,
      required: true
    },
    objects: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      testVal: 5,
      // show: true,
      objectProps: null,
      showPosition: true, showRotation: true, showScale: true,
      preventUpdateByWatch: true,
      // positionRange: { min: -30, max: 30 }, positionStep: 0.001,
      scaleStep: 0.0001
    }
  },
  computed: {
    ...mapStateAuth(['uid']),
    scaleRange () {
      // initialSize3dStage: 10.0,
      // initialSize3dObject: 0.4
      // if (this.targetAsset.originalInitialSize
      //   && ['3d_stage', '3d_object'].includes(this.targetAsset.type)) {
      //   const baseSize = this.targetAsset.originalInitialSize
      //   const biggerOriginalSize = (baseSize.w > baseSize.h) ? baseSize.w : baseSize.h
      //   // const initialSize = (this.targetAsset.type === '3d_stage') ? 
      //   //   this.initialSize3dStage : this.initialSize3dObject
      //   const initialScale = this.initialSize3dStage / biggerOriginalSize
      //   const resultRange = { min: 0, max: initialScale * 50 }
      //   // eslint-disable-next-line
      //   // this.scaleStep = (resultRange.max - resultRange.min) / 100
      //   return resultRange
      // }
      if (this.targetAsset.originalInitialSize
        && ['3d_stage'].includes(this.targetAsset.type)) {        
        // const box = new THREE.Box3().setFromObject(this.targetObject)
        // const wSize = box.max.x - box.min.x
        // const initialScale = this.initialSize3dStage / wSize
        return { min: 0, max: 10 }
      } else if (this.targetAsset.originalInitialSize
        && ['3d_object'].includes(this.targetAsset.type)) {
        return { min: 0, max: 5 }
      } else if (['actor'].includes(this.targetAsset.type)) {
        return { min: 0.8, max: 7.5 }
      } else {
        return { min: 0.1, max: 10 }
      }
    },
    positionRange () {
      if (['3d_stage'].includes(this.targetAsset.type)) {
        return { min: -30, max: 30 }
      } else {
        return { min: -10, max: 10 }
      }
    },
    positionStep () {
      if (['3d_stage'].includes(this.targetAsset.type)) {
        return 0.0001
      } else {
        return 0.001
      }
    },
    // scaleStep () {
    //   return (this.scaleRange.max - this.scaleRange.min)/100
    // }
  },
  watch: {
    objectProps: {
      handler () {
        if (this.preventUpdateByWatch) {
          this.preventUpdateByWatch = false
          return
        }
        this.$emit('setTargetObjectTransformProps', this.objectProps)
      },
      deep: true
    },
    // targetObject: {
    //   handler (currentObject, previousObject) {
    //     if (previousObject && previousObject.uuid !== currentObject.uuid) {
    //       this.setObjectProp()
    //     }
    //   },
    //   deep: true
    // }
    targetObject (currentObject, previousObject) {
      // if (!previousObject) {
      //   if (this.targetObjectMode === 'sprite') {
      //     this.objectProps = {
      //       position: { x: 0, y: 0, z: 0 },
      //       rotation: 0.0,
      //       scale: 1.0
      //     }
      //   } else if (this.targetObjectMode === 'mesh') {
      //     this.objectProps = {
      //       position: { x: 0, y: 0, z: 0 },
      //       rotation: { x: 0, y: 0, z: 0 },
      //       scale: 1.0
      //     }
      //   }
      // }

      // if (previousObject && previousObject.uuid !== currentObject.uuid) {
      //   this.preventUpdateByWatch = true // 選択しただけでアップデートされないようにする
      //   this.setObjectProp()
      // }

      this.setObjectProp()
    }
  },
  created () {
    // if (this.targetObjectMode === 'sprite') {
    //   this.objectProps = {
    //     position: { x: 0, y: 0, z: 0 },
    //     rotation: 0,
    //     scale: 1
    //   }
    // } else if (this.targetObjectMode === 'mesh') {
    //   this.objectProps = {
    //     position: { x: 0, y: 0, z: 0 },
    //     rotation: { x: 0, y: 0, z: 0 },
    //     scale: 1
    //   }
    // }

    this.setObjectProp()
  },
  destroyed () {
    this.preventUpdateByWatch = false
    this.objectProps = null
  },
  methods: {
    // updateTargetObject () {
    //   this.$emit('setTargetObjectTransformProps', this.objectProps)
    // },
    setObjectProp () {
      const objDoc = this.objects
        .filter(o => o.id === this.targetObject.userData.docId)[0]
      if (this.targetObjectMode === 'sprite') {
        // this.objectProps.position = this.toPosition(this.targetObject.position)
        // this.objectProps.rotation = this.targetObject.material.map.rotation
        // this.objectProps.scale = objDoc ? objDoc.scale.x : 1
        // console.log('objDoc:', objDoc)
        // console.log('objDoc.scale.x:', objDoc.scale.x)
        this.objectProps = {
          position: this.toPosition(this.targetObject.position),
          // rotation: this.targetObject.material.map.rotation,
          // scale: this.targetObject.scale.x
          rotation: objDoc.rotation,
          scale: objDoc ? objDoc.scale.x : 1
        }
      } if (this.targetObjectMode === 'mesh') {
        // this.objectProps.position = this.toPosition(this.targetObject.position)
        // this.objectProps.rotation = this.toRotation(this.targetObject.rotation)
        // this.objectProps.scale = objDoc ? objDoc.scale.x : 1
        
        this.objectProps = {
          position: this.toPosition(this.targetObject.position),
          rotation: this.toRotation(this.targetObject.rotation),
          scale: this.targetObject.scale.x
          // scale: objDoc ? objDoc.scale.x : 1
        }
      }
    },
    setPosition (x, y, z) {
      this.objectProps.position = { x, y, z }
    },
    setRotation (x, y, z) {
      this.objectProps.rotation = { x, y, z }
    }
  }
}
</script>
